$(document).ready ->
  $("[data-groups]").on "keyup", (event) ->
    if (!!document.searching_groups)
      clearTimeout(document.searching_groups)
      delete document.searching_groups
    document.searching_groups = setTimeout ->
      text = $(event.target).val()
      attr = $(event.target).attr("data-groups")
      groups_element = $(attr)
      if !!text
        $(groups_element).find("[data-group-name]").each ->
          name = $(this).attr('data-group-name').toLowerCase()
          unless name.indexOf(text.toLowerCase()) == -1
            $(this).css("display","block")
          else
            $(this).css("display","none")
      else
        $(groups_element).find("[data-group-name]").css("display","block")
    ,1000
